import { statusTypes } from 'ag-common/tools/fileStatus'
import i18n from 'i18next'
import PropTypes from 'prop-types'
import React from 'react'

const statusTexts = {
  [statusTypes.undefined]: 'misc_status_new',
  [statusTypes.draft]: 'misc_status_draft',
  [statusTypes.confirmed]: 'misc_status_confirmed',
  [statusTypes.submitted]: 'misc_status_submitted',
  [statusTypes.rejected]: 'misc_status_rejected',
  [statusTypes.new]: 'misc_status_new',
  [statusTypes.pending]: 'misc_status_pending',
}

function Status({status, canVerify, text, useGreyDraft = false}) {
  let style = 'status'
  let statusText = status

  switch (status) {
    case statusTypes.draft:
      style += ' status--draft'
      style += useGreyDraft ? ' status--draft-grey' : ' status--draft'
      break
    case statusTypes.rejected:
      style += ' status--rejected'
      break
    case statusTypes.confirmed:
      style += ' status--confirmed'
      break
    case statusTypes.submitted:
      if (canVerify) {
        statusText = statusTypes.new
        style += ' status--new'
      } else {
        style += ' status--submitted'
      }
      break
    case statusTypes.pending:
      style += ' status--pending'
      break
    default:
      break
  }

  let displayedText
  if (text && text !== status) {
    displayedText = text
  } else if (statusTexts[statusText]) {
    displayedText = i18n.t(statusTexts[statusText])
  } else {
    displayedText = i18n.t(status)
  }
  return <div className={style}>{displayedText}</div>
}

Status.propTypes = {
  status: PropTypes.string,
  text: PropTypes.string,
  canVerify: PropTypes.bool,
  useGreyDraft: PropTypes.bool,
}

export default Status
